<template>
  <div class="page-sign-in">
    <div class="page-sign-in__container">
      <p class="page-sign-in__header">Пожалуйста аутентифицируйтесь</p>
      <el-input
        placeholder="Login"
        v-model="login"
        class="page-sign-in__input"
        size="medium"
      ></el-input>
      <el-input
        placeholder="Password"
        v-model="password"
        class="page-sign-in__input"
        size="medium"
        type="password"
      ></el-input>

      <el-button size="medium" type="primary" round @click="handleSignIn">Login</el-button>
      <router-link to="signup" class="page-sign-in__register">Регистрация</router-link>
    </div>
  </div>
</template>

<script>
/**
 * Page: Страница аутентификации администратора
 *
 * @version 1.0.0
 */


import { mapActions } from 'vuex';


export default {
  name: 'page-sign-in',

  data() {
    return {
      login: '',
      password: '',
    };
  },

  methods: {
    async handleSignIn() {
      const { error } = await this.signIn({
        login: this.login,
        password: this.password,
      });

      if (error) {
        this.$notify({
          title: 'Authentication Error',
          message: error.message,
          duration: 0,
        });
      } else {
        this.$router.push('/');
      }
    },

    ...mapActions({
      signIn: 'user/signIn',
    }),
  },
};
</script>

<style lang="scss">
.page-sign-in {
  position: relative;
  width: 100vw;
  height: 100vh;

  &__header {
    text-align: center;
  }

  &__container {
    width: 240px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  &__input {
    margin-bottom: 10px;
  }

  &__register {
    margin-top: 16px;
    text-align: center;
    font-size: 12px;
  }
}
</style>

